import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=68f3817c&scoped=true&"
import script from "./order-item.vue?vue&type=script&lang=js&"
export * from "./order-item.vue?vue&type=script&lang=js&"
import style0 from "./order-item.vue?vue&type=style&index=0&id=68f3817c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f3817c",
  null
  
)

/* custom blocks */
import block0 from "./order-item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports